<template>
		<ul class="parent">
			<li v-for="category in orderedCategories" :key="category.id">
				<span>{{ category.name }}</span>
				<ul class="child">
					<li v-for="item in categoryLinks(category.id)">
						<a :href="item.url" target="_blank" :title="item.hover">{{ item.name }}</a>
					</li>
				</ul>
			</li>

		</ul>
</template>


<style scoped>

ul { color:#2d2d2d; }
li {font-size: 13px; line-height: 1.2; }
li:not(:last-child)  { border-bottom:1px solid #ccc;}
li:hover { background-color: #0fbdc9; color:#fff; }

.parent { position: relative; background: #f2f2f2; box-shadow:1px 1px 5px rgba(0,0,0,.4); }
.parent > li { display: block; padding:10px;}
.child { background: #f2f2f2; display: block; transition: transform .3s; box-shadow:1px 1px 5px rgba(0,0,0,.4); }
.child > li { display: block; }
.child > li a { color:inherit; display: block; padding: 10px; }


.categories-list ul { max-width: 300px; min-width: 200px;  }



.categories-list .parent {display:none; position: absolute; top:0; left:100%; }
.categories-list .parent li {position:relative; }
.categories-list .child {position: absolute; top:0; left:100%; visibility: hidden; transform: translateX(-30px);  }

.categories-list:hover .parent { display: block; }
.categories-list li:hover .child { visibility: visible; transform: translateX(0); z-index:2; }


.is-mobile .categories-list ul { min-width: 160px; }
.is-mobile .categories-list .parent {width:50%; display: block; top:initial; bottom:0; left:0; }
.is-mobile .categories-list .child{ bottom: 0; width: 100%; overflow: auto; }
.is-mobile .categories-list li:hover .child,
.is-mobile .categories-list li.active .child { visibility: visible; transform: translateX(0); z-index:2; top:initial; }





</style>

<script>

	export default {
		computed:{
			orderedCategories(){
				if(!this.$store.state.categories.categories.length) return [];
				return this.$store.state.categories.categories.slice().sort((a,b)=>{ return a.name.toLowerCase()>b.name.toLowerCase()?1:-1; });
			},

		},
		data() {
			return {
			}
		},
		methods:{
			categoryLinks(category_id){
				return this.$store.getters.categoryLinks(category_id).slice().sort((a,b)=>{ return a.name.toLowerCase()>b.name.toLowerCase()?1:-1; });
			},

		}
	}

</script>